import { getCurrentInstance } from 'vue';

export function useStore() {
    const vm = window.LBXFrontend?.$root || getCurrentInstance().proxy;
    return vm.$store;
}
